const INCREMENT_LOADING = 'INCREMENT_LOADING'
const DECREMENT_LOADING = 'DECREMENT_LOADING'

export {
  INCREMENT_LOADING,
  DECREMENT_LOADING
}
